import { imageAsset, link } from '@/data/sanity/fragments'
import { getMainDataOverrides, getLanguageQueryString } from '@/data/sanity/utils-language'
import menuItemCategory from './menuItemCategory'
import { STAGGERED_IMAGES_ITEM_FIELDS } from '@/data/sanity/fragments/sections/staggeredImages'

export const fields = `
  menuItemData {
    ${getLanguageQueryString([
      { name: 'category', fields: menuItemCategory.fields, dereference: true },
      'description',
      'subtitle',
      { name: 'disclaimers', isArray: true, fields: 'text, showAsterisk' },
      'isNew',
      'stamp',
      { name: 'images', isArray: true, fields: imageAsset.fieldsWithDataUri },
      { name: 'lifestyleImages', isArray: true, fields: imageAsset.fieldsWithDataUri },
      'heroImageStyle',
    ])}
  },
  ${getMainDataOverrides({
    objectSuffix: 'MenuItemData',
    mainObjectName: 'menuItemData',
    mainDataOverrides: ['title'],
  })}
  staggeredMediaContent {
    ${getLanguageQueryString([{ name: 'items', isArray: true, fields: STAGGERED_IMAGES_ITEM_FIELDS }])}
  },
  textAndImageContent {
    ${getLanguageQueryString([
      'isEnabled',
      'title',
      'description',
      { name: 'cta', isArray: true, fields: link.fields },
      { name: 'image', fields: imageAsset.fields },
    ])}
  }
`

export const fragment = (name = 'menuData') => `${name}{${fields}}`

const exported = {
  fields,
  fragment,
}

export default exported
